const allRightsReserved = {
  allRightsReserved: '2023 OH, My Ride Platform. All rights reserved.',
};
export default allRightsReserved;
